import axios from 'axios';
import { config } from '../config/environment';

const ADMIN_API_BASE_URL = config.coreApiUrl;

export const adminApi = axios.create({
  baseURL: ADMIN_API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

if (config.isDevelopment && config.features.debug) {
  console.log('🔌 Admin API Service initialized with base URL:', ADMIN_API_BASE_URL);
}

// Request interceptor to add auth token
adminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken') || localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      const token = localStorage.getItem('authToken') || localStorage.getItem('token');

      // Only redirect if we have a token and we're not already on login page
      // And avoid redirect loops if token is invalid
      if (token && currentPath !== '/admin/login' && !currentPath.startsWith('/admin/login')) {
        const preventRedirect = error.config?.preventAuthRedirect === true;

        if (!preventRedirect) {
          // Clear token and user data
          localStorage.removeItem('authToken');
          localStorage.removeItem('token');
          localStorage.removeItem('user');

          // Dispatch logout event to notify components
          window.dispatchEvent(new Event('userLogout'));

          // Redirect to admin login page
          window.location.href = '/admin/login?authFailed=true';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default adminApi;

